// NoInternet.jsx
import React from "react";
import { Box, Typography, Button } from "@mui/material";
import WifiOffIcon from "@mui/icons-material/WifiOff";

const NoInternet = () => {
const onRetry = () => {
    window.location.reload();
}

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <WifiOffIcon sx={{ fontSize: 80, color: "grey.500", mb: 2 }} />

      <Typography variant="h5" fontWeight="bold" gutterBottom>
        No Internet Connection
      </Typography>

      <Typography variant="body1" color="text.secondary" mb={3}>
        Please check your network settings and try again.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={onRetry}
        sx={{ px: 4, py: 1 }}
      >
        Retry
      </Button>
    </Box>
  );
};

export default NoInternet;